import { Injectable } from '@angular/core';
import {StepKey} from '../../core/enums/step-key.enum';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';

declare const dataLayer: any;

@Injectable({
  providedIn: 'root'
})
export class OlxAnalyticsService {

  private readonly STEP_EVENTS_MAP = {
    [StepKey.FIRST_STEP_1]: 'calculator_kp_step1a',
    [StepKey.FIRST_STEP_2]: 'calculator_kp_step1b',
    [StepKey.FIRST_STEP_3]: 'calculator_kp_step1c',
    [StepKey.SECOND_STEP]: 'calculator_kp_step2',
    [StepKey.THIRD_STEP]: 'calculator_kp_step3',
  };

  constructor() { }

  sendStepEvent(stepKey: StepKey): void {
    const stepEventName = this.STEP_EVENTS_MAP[stepKey];

    if (isNotNullOrUndefined(stepEventName)) {
      dataLayer.push({
        'trackEvent': [stepEventName],
      })
    }
  }

  sendPaymentEvent(): void {
    dataLayer.push({
      'trackEvent': ['calculator_kp_step_payment'],
    })
  }

  sendNotificationStepEvent(): void {
    dataLayer.push({
      'trackEvent': ['calculator_kp_step_typ'],
    })
  }
}
